export enum ActiveCountryTab {
  marketsOfSaleCountries = 'marketsOfSaleCountries',
  marketsOfSupportCountries = 'marketsOfSupportCountries',
  marketsOfDeliveryCountries = 'marketsOfDeliveryCountries'
}
